//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "create-delivery",
  data(){
    return{
      supList:[],
      login:null,
      orderNo:null,
      supId:null,
      noCreate:true,
      driverId:null
    }
  },
  methods:{
    goUser(){
      this.$router.push('/driver/mine');
    },
    createNew(){
      if(!this.orderNo){
        this.$vux.toast.text('请填写采购订单号');
        return;
      }
      let obj = {
        direction: "ASC",
        fromClientType: "pc",
        ignoreField: true,
        number: 0,
        property: "requireGoodsDateFrom",
        rules:[
          {
            collectIndex: -1,
            field: "purOrderDetail.purOrder.orderNo",
            option: "IN",
            values: [this.orderNo]
          }
        ],
        size:100
      };
      this.$loadingShow();
      this.$post('api/asn-dt/need/page',obj).then((res) => {
        if(res.content && res.content.length){
          this.$router.push(`/driver/new-delivery/${this.orderNo}`);
          this.$loadingHide();
        }else{
          obj.rules[0].field = 'purOrderDetail.purOrder.orderNoERP';
          this.$post('api/asn-dt/need/page',obj).then((res) => {
            if(res.content && res.content.length){
              this.$router.push(`/driver/new-delivery/${this.orderNo}/erpCode`);
            }else{
              this.$vux.toast.text('所输订单号没有需要送货的明细，请检查订单号是否正确');
            }
            this.$loadingHide();
          });
        }
      }).catch(() => {
        this.$loadingHide();
      });
    }
  },
  mounted(){

  }
}



// WEBPACK FOOTER //
// ./src/page/driver/create-delivery.vue